import React from 'react';
import { Box } from '@mui/material';
import Events from './events';
// import Assignment from './assignment';
import Project from './project';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Index = ({ currentBatch, setCurrentBatch }) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='opportunity'
          variant='scrollable'
          scrollButtons='auto'
        >
          <Tab label='Events' {...a11yProps(0)} />
          {/* <Tab label='Asignment' {...a11yProps(1)} /> */}
          <Tab label='Project Task' {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Events currentBatch={currentBatch} />
      </TabPanel>
      {/* <TabPanel value={value} index={1}>
        <Assignment currentBatch={currentBatch} />
      </TabPanel> */}
      <TabPanel value={value} index={1}>
        <Project currentBatch={currentBatch} />
      </TabPanel>
    </Box>
  );
};

export default Index;
